//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { CETELEM_POPUP_URL } from '~/const/3rd';

const PriceDiscount = () => import('~/components/molecules/Product/PriceDiscount.vue');

const ProductLot = () => import(
/* webpackMode: "eager" */
'~/components/atoms/Product/ProductLot.vue');

const EcoPartModal = () => import(
/* webpackMode: "eager"  */
'~/components/molecules/Product/Modal/EcoPartModal.vue');

const Sequra = () => import(
/* webpackMode: "eager" */
'~/components/atoms/Product/Sequra.vue');

export default {
  name: 'ThePriceSection',
  components: {
    PriceDiscount,
    ProductLot,
    Sequra
  },
  props: {
    price: {
      type: Object,
      required: true
    },
    loans: {
      type: Array,
      default: () => []
    },
    discountRate: {
      type: Number,
      default: null
    },
    isPrivateSales: {
      type: Boolean,
      default: false
    },
    priceType: {
      type: String,
      default: ''
    },
    lot: {
      type: Number,
      required: true
    },
    hasSequra: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      show20x: false,
      showModal: false,
      EcoPartModal: null
    };
  },

  computed: {
    cetelemPopupUrl() {
      return CETELEM_POPUP_URL;
    },

    cb() {
      if (!this.loans) return null;
      const filtredLoans = this.loans.filter(loan => loan.provider === 'CB');
      return filtredLoans ? filtredLoans[0] : null;
    },

    cetelem() {
      return this.loans ? this.loans.filter(loan => loan.provider === 'CETELEM') : null;
    },

    sales() {
      let salesInfo = {
        hasDiscount: false
      };

      if (this.priceType === 'P' && this.discountRate && !this.isPrivateSales) {
        salesInfo = {
          hasDiscount: true,
          rate: parseFloat(this.discountRate, 10) || '',
          base: this.price.base.formatted || ''
        };
      } else if (process.client && this.$cookies.get('fpe_sales')) {
        salesInfo = {
          hasDiscount: true,
          rate: parseFloat(this.$cookies.get('fpe_sales'), 10),
          base: this.$cookies.get('fpe_sales')
        };
      }

      return salesInfo;
    },

    ecoPart() {
      return this.$t('eco_part', {
        x: this.price.eco.formatted
      });
    },

    actualFormattedPrice() {
      return this.price.sales.amount ? this.price.sales.formatted : this.price.base.formatted;
    },

    actualPrice() {
      return this.price.sales.amount ? this.price.sales.amount : this.price.base.amount;
    }

  },
  methods: {
    openPopup(url) {
      window.open(url, 'Cetelem', 'height=700,width=800');
    },

    closeAction() {
      this.showModal = false;
    },

    showEcoPartModal() {
      this.EcoPartModal = EcoPartModal;
      this.showModal = true;
    },

    trackCredit(event) {
      this.$root.$emit('generic-tracking', event, {
        fn: 'track-event',
        data: {
          event_category: 'FicheProduit',
          event_action: 'Clic_paiement_sans_frais',
          event_label: "".concat(window.tc_vars.page_cat1, "/").concat(window.tc_vars.page_cat2, "/").concat(window.tc_vars.page_cat3, "/").concat(window.tc_vars.page_cat4, "/").concat(window.tc_vars.page_cat5)
        }
      });
    }

  }
};